
define('text!modules/strategy/creatives/templates/bin_footer.html',[],function () { return '<dl class="headers weighting-flag">\n\t<dt class="header column footer-title"></dt>\n\t<dd class="header column total-weight"></dd>\n\t<div class="icon-spinner-footer"></div>\n</dl>';});

